






















































import { Component, Vue } from "vue-property-decorator"
import { initialState } from "../store/initial"
import { rounds } from "../game_content/rounds"
import { EnergySource } from "@/models/energy-source"
import { saveAs } from "file-saver"

@Component
export default class GameOverScreen extends Vue {
  // Decorators: https://github.com/kaorun343/vue-property-decorator
  // Class: https://github.c  om/vuejs/vue-class-component

  get playerWon() {
    return this.$store.getters.playerWon
  }

  get allPlayerHistory() {
    // return this.$store.state.history.getAllHistoryAsString()
    let returnVal = ""
    let index = 1
    for (const h of this.$store.state.history.history) {
      let temp = ""
      const roundStr = `<b><p>Round ${index}\n</p></b>`
      if (h != null) {
        const elements: EnergySource[] = Array.from(h.keys())
        for (const element of elements) {
          const num = h.get(element)!
          temp += `<p>${element.name}: ${num} units, ${element.mwatts *
            num} MW</p>`
        }
      }
      if (temp !== "") {
        returnVal += roundStr + temp
      }
      index++
    }
    if (returnVal === "") {
      returnVal = "No purchases made."
    }
    return returnVal
  }

  get climateLoss() {
    return this.$store.state.pollution > this.$store.state.pollutionThreshold
  }

  get totalEnergyMade() {
    let sum = 0
    for (const h of this.$store.state.history.history) {
      if (h != null) {
        const elements: EnergySource[] = Array.from(h.keys())
        for (const element of elements) {
          const num = h.get(element)!
          sum += element.mwatts * num
        }
      }
    }
    return sum
  }

  get allPlayerHistoryRaw() {
    // return this.$store.state.history.getAllHistoryAsString()
    const returnVal = []
    let index = 1
    for (const h of this.$store.state.history.history) {
      const temp = []
      const roundStr = `Round ${index}\n`
      if (h != null) {
        const elements: EnergySource[] = Array.from(h.keys())
        for (const element of elements) {
          const num = h.get(element)!
          temp.push(
            `${element.name}: ${num} units, ${element.mwatts * num} MW\n\n`
          )
        }
      }
      if (temp.length !== 0) {
        returnVal.push(roundStr)
        returnVal.push(...temp)
      }
      index++
    }
    if (returnVal.length === 0) {
      returnVal.push("No purchases made.\n\n")
    }
    returnVal.push("Climate Change\n\n")
    returnVal.push(`Pollution Amount: ${this.$store.state.pollution}\n`)
    returnVal.push(
      `Pollution Maximum: ${this.$store.state.pollutionThreshold}\n\n`
    )
    returnVal.push(`Player's Money Remaining: $${this.$store.state.money}\n\n`)
    if (this.playerWon && !this.climateLoss) {
      returnVal.push(`Game result: Player Wins!\n`)
    } else {
      returnVal.push(`Game result: Player Lost!\n`)
    }
    return returnVal
  }

  protected downloadData() {
    const blob = new Blob(
      [`Completed At: ${new Date()}\n`, ...this.allPlayerHistoryRaw],
      {
        type: "text/plain; charset=utf-8"
      }
    )
    saveAs(blob, "results.txt")
  }

  protected startOver() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Click.mp3"]
      }).play()
    }
    const newState = initialState()
    newState.muted = this.$store.state.muted
    newState.firstLoad = this.$store.state.firstLoad
    this.$store.replaceState(newState)
    this.$store.commit("RETRIEVE_MARKDOWN", rounds())
  }
}
